<template>
  <div class="list-mode-item">
    <!--        thumbnail-archived-->
    <!--        thumbnail-ended-->
    <!--        <pre>{{event}}</pre>-->
    <div class="l-m-thumbnail bg-empty-card relative">
      <div v-if="eventStatus" class="absolute bottom-3 right-3 z-10 px-2 py-1 rounded-md text-sm"
        :class="eventStatus.class">{{eventStatus.text}}</div>

      <router-link :to="{name: 'event', params: {eventId: event.id}}">
        <img v-if="event.featuredImage && event.featuredImage.url" :src="event.featuredImage.url" :alt="event.name">
      </router-link>
    </div>
    <div class="l-m-body flex flex-col">
      <div>
        <span class="mt-1 sm:mb-0 primary-color text-sm font-semibold">
          {{ event.startDate | dateFormatTz("MMMM DD @ h:mma z", event.timezone) }}
        </span>
        <h2 class="h2 fw-600">
          <router-link :to="{name: 'event', params: {eventId: event.id}}">{{ event.name }}</router-link>
        </h2>
      </div>

      <div class="statistics">
        <div>
          <span class="statistics-value">{{ (event.stock && event.stock.grossSales) || 0 }}</span><span
            class="caption">Sold</span>
        </div>
        <div>
          <span class="statistics-value">${{ ((event.stock && event.stock.revenue) || 0) / 100 | formatMoney
          }}</span><span class="caption">Revenue</span>
        </div>
        <div>&nbsp;<span class="caption">&nbsp;</span></div>

        <el-dropdown v-if="event" trigger="click" @command="handleCommand">
          <el-button type="primary" size="medium">Options</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="['edit', event]">Edit</el-dropdown-item>
            <el-dropdown-item :command="['view-tickets', event]">Tickets</el-dropdown-item>
            <el-dropdown-item :command="['archive', event]">Archive</el-dropdown-item>
            <!-- <el-dropdown-item :command="['duplicate', event]">Duplicate</el-dropdown-item> -->
            <el-dropdown-item :command="['view-details', event]">View Details</el-dropdown-item>
            <el-dropdown-item :command="['event-page', event]">Event Page</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import EventProgress from './progress';
const moment = require('moment');

export default {
  name: "event-card",
  components: {
    EventProgress,
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleCommand([command, payload]) {
      this.$emit('command', [command, payload]);
    }
  },
  computed: {
    eventStatus() {
      // Priority set for Archived
      if (this.event.deletedAt) {
        return { text: 'Archived', class: 'bg-red-500 text-white' };
      }
      if (moment(this.event.startDate) < moment() && moment(this.event.endDate) > moment()) {
        return { text: 'Ongoing Event', class: 'bg-blue-500 text-white' };
      }
      if (moment(this.event.endDate) < moment()) {
        return { text: 'Past Event', class: 'bg-yellow-500 text-white' };
      }
      return null
    }
  }
}
</script>

<style lang="sass" scoped>
.list-mode-item
  overflow: visible
  position: relative

  .dropdown
    .btn
      box-shadow: none

  .dropdown-content
    width: 180px
    font-weight: 400
  
  .primary-color
    color: #0d70e3

  .statistics
    .statistics-value
      font-size: 15px

</style>